<template>
  <div v-if="visibleMsgCookies" class="cookie-consent">
    <div class="t-block-cookies">
      <div class="t-block-cookies__container t-container">
        <p class="t-block-cookies__text">
          <slot></slot>
        </p>
        <div class="t-block-cookies__actions">
          <button type="button" class="t-btn _green _big" @click="acceptCookiesAll()">
            {{ $root.staticText.common.accept }}
          </button>
          <button type="button" class="t-btn _gray _big" @click="openCookieSettingModal()">
            {{ $root.staticText.common.settings }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { consentService, DEFAULT_CONSENT } from '@shared/services/consent'
import { MODAL_TYPE_RESULT } from '@shared/const/modal.const'

export default {
  name: 'cookie-consent',
  data() {
    return {
      visibleMsgCookies: false,
    }
  },
  async created() {
    const consent = consentService.getConsent()

    this.visibleMsgCookies = !consent?.decided

    if (!consent) {
      consentService.setConsent(DEFAULT_CONSENT)
      await consentService.sendLog()
    }

    if (!consent || consent?.decided) {
      await consentService.applyConsent()
    }
  },
  computed: {
    ...mapGetters({ modalResult: 'modal/modalResult' }),
  },
  methods: {
    ...mapActions('modal', ['modalType_consentOpen']),

    async acceptCookiesAll() {
      consentService.setAllConsent()
      this.visibleMsgCookies = false
      await consentService.applyConsent()
      await consentService.sendLog()
    },

    async openCookieSettingModal() {
      await this.modalType_consentOpen()
    },
  },
  watch: {
    async modalResult(result) {
      if (result?.type === MODAL_TYPE_RESULT.consentSave) {
        consentService.setConsent(result.data)
        await consentService.applyConsent()
        this.visibleMsgCookies = false
        await consentService.sendLog()
      }
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/modules/shared/ui/CookieConsent.vue